import { Component, OnInit, TemplateRef, ViewChild, Input, OnDestroy } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { UsersService, ErrorService } from '@shared/services';
import { Subject } from 'rxjs';
import { takeUntil, first } from 'rxjs/operators';
import { environment } from '@environment/environment';

@Component({
  selector: 'app-user-info-popup',
  templateUrl: './user-info-popup.component.html',
  styleUrls: ['./user-info-popup.component.scss']
})
export class UserInfoPopupComponent implements OnInit, OnDestroy {

  @ViewChild('UserInfoForm', { static: true }) UserInfoformModal: TemplateRef<any>;
  @Input() selectedUserContactId: any;

  modalRefUser: BsModalRef | null;
  ContactName: any;
  GroupName: any;
  currentContact: any;

  private _unsubscribeAll$ = new Subject<void>();

  constructor(
    private modalService: BsModalService,
    private _usersService: UsersService
  ) { }

  ngOnInit(): void {
    if (this.selectedUserContactId) {
      this.getContactById(this.selectedUserContactId);
    }
    
  }

  getContactById(contactId): void {
    this._usersService
      .getcontactById(contactId)
      .pipe(takeUntil(this._unsubscribeAll$), first())
      .subscribe(
        (result) => {
          this.currentContact = result.data;
          console.log('Contact loaded:', this.currentContact);
        },
        (error) => {
          console.error('Error fetching contact:', error);
        }
      );
  }

mediaUrl: string = environment.AttachmentUrl.endsWith('/')
  ? environment.AttachmentUrl
  : environment.AttachmentUrl + '/';

  openUserInfoModal(SelectedUser): void {
    // this.GroupName = SelectedUser.groupName;
    // this.ContactName = SelectedUser.fullName;
    this.ContactName = null;
    this.GroupName = null;
    this.currentContact == null;
    this.getContactById(SelectedUser.contactId);

    const configs = {
      keyboard: false,
      ignoreBackdropClick: true,
       class: ' modal-lg modal-primary  ModelPopUpLayoutFilterPopUps commenModel  fadeInCenter',
      animated: false
    };
    this.modalRefUser = this.modalService.show(this.UserInfoformModal, configs);
  }

  closeAddEditModalUser(): void {
    if (this.modalRefUser) {
      this.modalRefUser.hide();
    }
     this.ContactName = null;
  this.GroupName = null;
  this.currentContact == null;
  }

  ngOnDestroy(): void {
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }
}
